"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollSettings = void 0;
const getScrollSettings = event => {
  const domNode = event.target;
  const {
    scrollHeight,
    clientHeight,
    scrollLeft,
    scrollTop,
    scrollWidth,
    clientWidth
  } = domNode;
  const hasVerticalScroller = scrollHeight > clientHeight;
  const hasHorizontalScroller = scrollWidth > clientWidth;
  const scrollerAtBottom = scrollTop + clientHeight + 100 >= scrollHeight;
  const scrollerAtTop = scrollTop <= 0;
  const scrollerAtLeft = scrollLeft <= 0;
  const scrollerAtRight = scrollLeft + clientWidth + 100 >= scrollWidth;
  const scrollSettings = {
    scrollHeight,
    scrollLeft,
    clientHeight,
    clientWidth,
    hasVerticalScroller,
    hasHorizontalScroller,
    scrollTop,
    scrollWidth,
    scrollerAtBottom,
    scrollerAtTop,
    scrollerAtLeft,
    scrollerAtRight,
    event
  };
  return scrollSettings;
};
exports.getScrollSettings = getScrollSettings;